import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { listSnapshotsListenerSaga } from './list-snapshots';
import { loadSnapshotsListenerSaga } from './load-snapshots';

export function* rootSaga(): SagaIterator {
    yield all([fork(listSnapshotsListenerSaga), fork(loadSnapshotsListenerSaga)]);
}
